import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    address: {
      label: translate({ id: 'global.address' }),
    },
    bannedTags: {
      label: (count: number) => {
        if (count === 0) return translate({ id: 'orders.configuration.bannedTags' })
        return translate({ id: 'orders.configuration.bannedTags.withCount', values: { count } })
      },
    },

    company: {
      label: translate({ id: 'orders.viewDetails.label.company' }),
    },
    priority: {
      label: translate({ id: 'global.importance' }),
    },
    violation: (violationType: uui.domain.rm.RouteStepViolationsType) => {
      switch (violationType) {
        case 'ELG':
          return translate({ id: 'rm.scheduler.violations.routeStep.eligibility' })
      }
    },
    eligibility: {
      label: translate({ id: 'global.eligibility' }),
      value: ({ type }: uui.domain.client.rm.Eligibility, dateAsString: string): string => {
        switch (type) {
          case 'any':
            return translate({ id: 'global.eligibility.any' })

          case 'on':
            return translate({
              id: 'global.eligibility.on',
              values: { date: dateAsString },
            })

          case 'by':
            return translate({
              id: 'global.eligibility.by',
              values: { date: dateAsString },
            })
        }
      },
    },
    loads: {
      label: translate({ id: 'global.loads' }),
    },
    vehicle: {
      label: translate({ id: 'orders.configuration.requiredVehicle' }),
    },
    type: {
      label: translate({ id: 'global.type' }),
      value: (orderStepType: uui.domain.client.rm.OrderStepIdentifier): string => {
        switch (orderStepType) {
          case 'p':
            return translate({ id: 'global.pickup' })
          case 'd':
            return translate({ id: 'global.delivery' })
          case 's':
            return translate({ id: 'global.service' })
        }
      },
    },
    contactInformation: {
      title: translate({ id: 'orders.edit.titles.customerContact' }),
      phone: {
        label: translate({ id: 'orders.edit.field.phone' }),
      },
      email: {
        label: translate({ id: 'orders.edit.field.email' }),
      },
    },
    requiredTags: {
      label: (count: number) => {
        if (count === 0) return translate({ id: 'orders.configuration.requiredTags' })
        return translate({ id: 'orders.configuration.requiredTags.withCount', values: { count } })
      },
    },
    serviceTime: {
      title: translate({ id: 'orders.edit.titles.serviceTime' }),
      label: translate({ id: 'orders.configuration.serviceTime' }),
    },
    timeWindows: {
      label: translate({ id: 'orders.configuration.timeWindows' }),
    },
    timeWindowsExceptions: {
      label: translate({ id: 'orders.configuration.timeWindowsExceptions' }),
    },
    customFields: {
      label: translate({ id: 'orders.configuration.customFields' }),
    },
    barcodes: {
      label: translate({ id: 'orders.field.barcode.label' }),
    },
    notes: {
      label: translate({ id: 'global.notes' }),
    },
    additionalDetails: {
      title: translate({ id: 'orders.additionalDetails.title' }),
    },
  }))

  return api
}
